import React, { useRef } from 'react';
import { get as _get } from 'lodash';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { useIntl } from 'react-intl';

import useOnScrollHorizontal from 'newDesign/modules/common/hooks/OnScrollHorizontal';
import { SEC } from 'constants/app';

import style from '../FooterCrawler.scss';


const LeagueStandings = ({ teams, table }) => {
  const intl = useIntl();
  const scrollEndRef = useRef(null);
  const scrollPosition = useOnScrollHorizontal(scrollEndRef, 3, 60 * SEC);
  const crawlerDivRef = useRef(null);
  const currentMatchTeams = [teams.home[0].name, teams.away[0].name];

  const renderPointsOrResults = team => {
    // Highest priority - points
    if (team.pts !== undefined && team.pts !== null) {
      const ptsLabel = intl.formatMessage({ id: 't_statistics_pts' }).toLowerCase();
      return `${team.pts}${ptsLabel}`;
    }
    // If there are no points, display: W wins:losses L (localized labels).
    if (team.wins !== undefined && team.losses !== undefined) {
      return `${intl.formatMessage({ id: 't_statistics_w' })} ${team.wins}:${team.losses} ${intl.formatMessage({ id: 't_statistics_l' })}`;
    }

    return '-';
  };

  /**
 * Calculate width because TV screen has different resolution and crawler container on the bottom as well
 * We need to move position of the text to the right, depending on the width of container
 * Text needs to start scrolling from the right and move to the left, initially text is invisible
 */
  const widthCrawlerContainer = _get(crawlerDivRef, 'current.clientWidth', 0);

  /**
 * Start position from the right side and add width of container and + 100px for initial padding
 * @type {number}
 */
  const marginLeft = -scrollPosition + widthCrawlerContainer + 100;

  return (
    <div
      ref={crawlerDivRef}
      styleName='textMarquee'
      className='flex flex-1 relative'
      style={{ left: `${marginLeft}px` }}
    >
      {table.map(tableTeam => {
        const isCurrentMatchTeam = currentMatchTeams.includes(tableTeam.name);

        return (
          <div className='font-second fs-16 uppercase flex items-center' key={tableTeam.name}>
            <span styleName={`position ${isCurrentMatchTeam ? 'active' : ''}`}>{'#' + tableTeam.pos}</span>
            <span styleName={isCurrentMatchTeam ? 'active' : ''}>{tableTeam.name.toUpperCase()}</span>
            <span>{renderPointsOrResults(tableTeam)}</span>
          </div>
        );
      })}
      <div style={{ marginLeft: `${widthCrawlerContainer}px` }} ref={scrollEndRef} />
    </div>
  );
};

LeagueStandings.propTypes = {
  teams: PropTypes.object.isRequired,
  table: PropTypes.array.isRequired,
};

const LeagueStandingsStyled = cssModule(LeagueStandings, style, { allowMultiple: true });
export default LeagueStandingsStyled;
